import { Box, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { ServiceStopEntry } from '../../../apis/serviceHistoryApi';

interface ServiceEntryTableProps {
  heading: string;
  entries?: ServiceStopEntry[] | null;
  showUom?: boolean;
}

const ServiceEntryTable: React.FC<ServiceEntryTableProps> = ({ entries, heading }) => {
  if (!entries) {
    return null;
  }
  return (
    <Box mt={4} ml={1} maxWidth={300}>
      <Typography variant="subtitle2" ml={1} fontWeight={600}>
        {heading}
      </Typography>
      <Table sx={{ marginTop: 2 }}>
        {entries.length === 0 && (
          <TableBody>
            <TableCell
              sx={{
                borderWidth: 1,
                borderColor: (theme) => theme.palette.divider,
                borderStyle: 'solid',
                padding: 2,
              }}
            >
              None
            </TableCell>
          </TableBody>
        )}
        {entries.length > 0 && (
          <TableBody>
            {entries.map((entry, index) => (
              <TableRow key={`reading_${index}`}>
                <TableCell
                  sx={{
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    padding: 2,
                    columnWidth: 100,
                  }}
                >
                  {entry.description}
                </TableCell>
                <TableCell
                  sx={{
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    padding: 2,
                    paddingLeft: 1,
                    fontWeight: 600,
                    opacity: 0.6,
                    columnWidth: 20,
                    alignItems: 'right',
                  }}
                >
                  <Box minWidth={20} textAlign="right">
                    {entry.value}
                  </Box>
                </TableCell>
                <TableCell
                  sx={{
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    padding: 2,
                    paddingRight: 1,
                    fontWeight: 600,
                    opacity: 0.6,
                    columnWidth: 10,
                  }}
                >
                  <Box minWidth={20}>{entry.unitOfMeasure}</Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </Box>
  );
};

export default ServiceEntryTable;
